import { render, staticRenderFns } from "./foreMains.vue?vue&type=template&id=4a3186cb&scoped=true&"
import script from "./foreMains.vue?vue&type=script&lang=js&"
export * from "./foreMains.vue?vue&type=script&lang=js&"
import style0 from "./foreMains.vue?vue&type=style&index=0&id=4a3186cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3186cb",
  null
  
)

export default component.exports